import { PaymentElement } from '@stripe/react-stripe-js';

type Props = {
  processing?: boolean;
};

export function PaymentField({ processing = false }: Props) {
  return (
    <PaymentElement
      options={{
        terms: { card: 'never' },
        layout: {
          type: 'tabs',
          defaultCollapsed: false,
        },
        readOnly: processing,
      }}
    />
  );
}
